import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'push' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/push.js.map
